import React from 'react'

import "./footer.css";

const Footer = () => {
    return (
    <footer className="footer">
        <div className="footer__container container">
            <h1 className="footer__title">ziyadoodle.</h1>

            <ul className="footer__list">
                <li>
                    <a href="#about" className="footer__link">About</a>
                </li>
                <li>
                    <a href="#qualification" className="footer__link">Experience</a>
                </li>
                <li>
                    <a href="#portfolio" className="footer__link">Projects</a>
                </li>
            </ul>

            <div className="footer__social">
                <a href="https://github.com/ziyadoodle" className="footer__social-link" target="_blank"
                    rel="noreferrer">
                    <i className="bx bxl-github"></i>
                </a>
                <a href="https://www.instagram.com/zydzdnee" className="footer__social-link" target="_blank"
                    rel="noreferrer">
                    <i className="bx bxl-instagram"></i>
                </a>
                <a href="https://dribbble.com/ziyadoodle" className="footer__social-link" target="_blank"
                    rel="noreferrer">
                    <i className="bx bxl-dribbble"></i>
                </a>
            </div>

            <span className="footer__copy">&#169; Ziyad Zidane. 2022. All rigths reserved</span>

        </div>
    </footer>
    )
}

export default Footer